import { isAxiosError } from 'axios';
import { isRecord } from 'utils/typeGuards';

// Response access stays separate from display formatting so session startup
// can classify failures without loading validation messages and translations.

/**
 * Shape of the error payloads this app sees: AxiosErrors carry `response`, and a
 * few call sites throw plain response-shaped objects. FastAPI puts the useful
 * message under `response.data.detail` (a string for most endpoints, an object
 * like `{ code }` for a few).
 */
export function getResponseRecord(
  error: unknown
): Record<string, unknown> | undefined {
  if (!isRecord(error) || !isRecord(error.response)) {
    return undefined;
  }
  return error.response;
}

/** The HTTP status off an axios error (or response-shaped throw), if present. */
export function getApiErrorStatus(error: unknown): number | undefined {
  if (isAxiosError(error)) {
    return error.response?.status;
  }
  const status = getResponseRecord(error)?.status;
  return typeof status === 'number' ? status : undefined;
}
